import React, {cloneElement, useContext, useEffect, useState} from 'react';
import {TableColumn, TableSettings} from '../../../tableSettings';
import {
  DateRenderer,DateTimeRenderer, FloatRenderer, TextAlignLeftWithAddressTooltipRenderer,
  NullableCheckboxIconRenderer, TextAlignLeftRenderer,TextAlignRightRenderer,TextRenderer
} from '../../../uiControls/SmartTableRenderers';
import UniqueLinkButton from '../../../uiControls/UniqueLinkButton';
import PrimaryButton from '../../../ui/PrimaryButton';
import {NavigationType, openNewPage} from '../../../util/navigationHelpers';
import JobListViewContext, {IJobListViewContext, RightClickContext} from '../../common/JobListViewContext';
import lockBlue from '../../../img/lock_blue.png';
import lockRed from '../../../img/lock_red.png';
import AbstractListView, {
  DataFetchResult,ExportRowRenderer,ListCustomFilterRenderer,ListOrderBy,ListRowRenderer
} from "../../common/AbstractListView";
import {Search} from '../../../filtering';
import {JobNames} from '../../../framework.core/JobNames';
import {airExportHawbList} from '../tableSettings';
import {AeHblListItem} from '../../../fms.data/models/AeHblListItem';
import useGlobalOkDialog from '../../../hooks/useGlobalOkDialog';
import {ActionButtonItem, borderColors, splitMenuItemsIntoSections} from '../../../ui/ActionButton';
import {useHistory} from 'react-router';
import useGlobalYesNoDialog from '../../../hooks/useGlobalYesNoDialog';
import useFunctionKeys from '../../../hooks/useFunctionKeys';
import ApplicationContext from '../../../ApplicationContext';
import InfoAreaDrawer from '../../../uiControls/infoArea/InfoAreaDrawer';
import loadInfoAreaInvoiceBillCrDb from '../../common/InfoAreaInvoiceBillCrDb';
import BlackInverseButton from "../../../ui/BlackInverseButton";
import IfmsModal from "../../../ui/IfmsModal";
import ListViewShortcutMenu from '../../common/ListViewShortcutMenu';
import fastStorage from '../../../fastStorage';
import HawbBlStatusPopup from './HawbBlStatusPopup';
import {ReactComponent as ContainerTrackingIcon} from "../../../img/container_tracking.svg";
import ToolboxMenuItem from '../../../uiControls/ToolboxMenuItem';
import Menu, { IfmsMenuItem } from '../../../ui/menu/Menu';
import { FmsSubMenu } from '../../../constants/fmsSubMenu';
import { getSelectedSubMenuArgs } from '../../JobListSubMenu';
import useReportViewer from '../../../hooks/useReportViewer';
import JobListSuntekCommand from '../../common/JobListSuntekCommand';
import { BillingsRenderer, BillInvoiceCrdbFilterRenderer, RecognizedFilterRenderer, RecognizedRenderer, ShipmentTypeFilterRenderer, ShipmentTypeRenderer } from '../../common/commonListRenderers';
import { getFmsGlobal } from '../../../globals';
import * as XCol from '../../../framework.core/XExportColumn';
import DeleteHistory from "../../reports/DeleteHistory";
import postal from 'postal';
import useSetEditedId from '../../../hooks/useSetEditedId';
import Select from '../../../ui/Select';
import { FmsSecTask } from '../../../fms.core/constants';
import { SuntekSettings, SystemSettings } from '../../../ifmsTypes';
import { findSecurityTask } from '../../../util';
import { useJournal } from '../../accounting/general/journal/JournalListView';
import useSuntekSettings from '../../../hooks/useSuntekSettings';
import PrimaryInverseButton from '../../../ui/PrimaryInverseButton';
import _ from 'lodash';
import RecogModal from '../../../ui/RecogModal';
import constants from '../../../constants';
import { formatAEBlType, formatShipmentType } from '../../common/utils/formatUtils';
import { Decimalformat } from '../../common/commonExportFormat';

function IndicatorRenderer({ data, row }: any) {
  const l = data[row.index];
  let dataTooltip = '';
  const lStatus = (l as any).status as string;
  if (lStatus === 'PC') dataTooltip = 'Period Close';
  else if (lStatus === 'OC') dataTooltip = 'OP Close';

  // function onIndicatorClick() {
  //   if (jobListContext.rowExtrasId) {
  //     return; // Some row is already selected
  //   }
  //   jobListContext.setRowExtrasId(data[row.index].id);
  // }

  let content: React.ReactNode = <></>;
  //if ((l as any).isClosed) {
  if (lStatus === 'PC')
    content = <img height="7px" src={lockRed} id={'redIcon'} style={{ position: 'relative', top: '0px' }} alt="" />;
  else if (lStatus === 'OC')
    content = <img height="7px" src={lockBlue} id={'blueIcon'} style={{ position: 'relative', top: '0px' }} alt="" />;
  //}

  return (
    //<div className="ifms-table-default" data-tooltip="B/L Status" style={{width: '100%', minHeight: '22px', cursor: 'pointer'}} onClick={onIndicatorClick}>{content}</div>
    <div className="ifms-table-default" id={`ifms-table-default-${row.index}`} data-tooltip={dataTooltip} style={{ width: '100%', minHeight: '22px' }}>{content}</div>
  );
}

function BlTypeRenderer({cell}:any) {
  let value = '';

  if (cell.value === 'D') {
    value = 'Regular';
  } else if (cell.value === 'C') {
    value = 'Consol';
  } else if (cell.value === 'L') {
    value = 'Co-Load';
  }

  return (
    <div className="ifms-table-default" data-cell-actual-value={cell.value}>{value}</div>
  );
}

function BlTypeFilterRenderer({value, onChange}:any) {
  return (
    <Select
      name='ifms-filter-blType-select'
      value={value}
      onChange={e => onChange(e.target.value)}
      items={[
        // { label: '', value: '' },
        { label: 'Regular', value: 'D' },
        { label: 'Consol', value: 'C' },
        { label: 'Co-Load', value: 'L' },
      ]}      
    />
  );
}

function PaidRenderer({value, data, row}: any) {
  const {switchToAcctInfo} = useHawbOperations();

  const isPaid = value !== 'x';

  if (!isPaid) {
    return <div className="ifms-table-default">{value}</div>;
  }

  return <PrimaryInverseButton onClick={() => switchToAcctInfo(data[row.index])} style={{width: '100%', lineHeight:'1em'}}>{value}</PrimaryInverseButton>
}

function useHawbOperations() {
  const history = useHistory();
  const jobListContext = useContext(JobListViewContext);

  function switchToMawbFor(hawb: AeHblListItem | null) {
    if (!hawb) {
      return;
    }

    jobListContext.setFilterForScreenExternally('/common/joblistview/aeMawb/airExport', 
    'id', 'Ref. #', hawb.aeMblId, 'updated', false, true, null, 'refNo', hawb.refNo, false,true);
    openNewPage(history, `/common/joblistview/aeMawb/airExport`, NavigationType.newPage);
  }

  async function switchToAcctInfo(hawb:AeHblListItem|null) {
    if (!hawb) {
      return;
    }

    let link = `/accounting/Acct/${JobNames.AEHbl}/${hawb.id}`;

    jobListContext.moveToOpenedScreenInAnyOperationStartingWithUrl(link, [link]);
  }

  return {switchToMawbFor, switchToAcctInfo};
}

function useSelectedHawbOperation() {
  const appContext = useContext(ApplicationContext);
  const jobListContext = useContext(JobListViewContext);
  const history = useHistory();
  const { switchToMawbFor } = useHawbOperations();

  const selectedElement = jobListContext.selectedElement as AeHblListItem;

  const [showGlobalOkDialog] = useGlobalOkDialog();
  const [showGlobalYesNoDialog] = useGlobalYesNoDialog();
  const channel = postal.channel('ajax');

  const setSavedEntityAem = useSetEditedId([JobNames.AEMbl]);

  async function create() {
    if (jobListContext.hasOpenedScreenStartingWithUrl('/airExport/hawb/add')) {
      await showGlobalOkDialog(<p>New operation is already in progress.</p>);
      return;
    }

    const openedByF6 = jobListContext.openedByF6 &&
      !!jobListContext.f6Query &&
      jobListContext.f6Origin === '/common/joblistview/aeMawb/airExport';

    const openedByMaster = jobListContext.openedByF6 &&
      !!jobListContext.f6Query &&
      jobListContext.f6Origin === '/airExport/mawb/edit/' + jobListContext.f6Query;

    const newUrl = openedByF6 || openedByMaster
      ? `/airExport/hawb/add?mawbRefId=${jobListContext.f6Query}`
      : '/airExport/hawb/add';

    openNewPage(history, newUrl, NavigationType.newPage);
  }

  async function deleteHbl() {
    if (!selectedElement) {
      return;
    }

    if (
      jobListContext.hasOpenedScreenStartingWithUrl(`/airExport/hawb/edit/${selectedElement.id}`) || 
      jobListContext.hasOpenedScreenStartingWithUrl(`/airExport/hawb/view/${selectedElement.id}`)
    ) {
      await showGlobalOkDialog('Need to close HAWB first', false, null, "warning");
      return;
    }

    if (
      jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(`/accounting/bill/view/hawb/${selectedElement.id}`) ||
      jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(`/accounting/bill/edit/hawb/${selectedElement.id}`) ||
      jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(`/accounting/invoice/view/hawb/${selectedElement.id}`) ||
      jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(`/accounting/invoice/edit/hawb/${selectedElement.id}`) ||
      jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(`/accounting/crdb/view/hawb/${selectedElement.id}`) ||
      jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(`/accounting/crdb/edit/hawb/${selectedElement.id}`)
    ) {
      await showGlobalOkDialog('Need to close Bill/Invoice/CrDb first.',false,null,'warning');
      return;
    }

    const doDelete = await showGlobalYesNoDialog(
      <div>
        <h3>Confirm to Delete?</h3>
      </div>
    ,false, 0, true, 'warning');

    if (doDelete) {
      const apiResult = await appContext.api.deleteJobDetail(JobNames.AEHbl, { id:selectedElement.id, pimsLinkId: selectedElement.pimsLinkId });
      if (apiResult && apiResult.success) {
        jobListContext.reloadData();
        setSavedEntityAem(selectedElement.aeMblId?.toString(), false);
      } else {
        const message = apiResult?.message ?? 'Cannot delete!';
        await showGlobalOkDialog(message,false,null,'warning');  
      }
    }
  }

  async function edit() {
    if (!selectedElement) {
      return;
    }

    const id = selectedElement.id;
    const editUrl =`/airExport/hawb/edit/${id}`;
    const viewUrl = `/airExport/hawb/view/${id}`;

    // if (jobListContext.hasOpenedScreenStartingWithUrlWithoutMe('/airExport/hawb/edit', editUrl)) {
    //   await showGlobalOkDialog(<p>Edit operation is already in progress.</p>);
    //   return;
    // }

    jobListContext.moveToOpenedScreenInAnyOperationStartingWithUrl(editUrl, [editUrl, viewUrl]);
  }

  async function viewBillings() {
    if (!selectedElement) {
      return;
    }

    const id = selectedElement.id;

    const viewUrl = `/AirExport/viewBillings/hawb/${id}`;

    openNewPage(history, viewUrl, NavigationType.newPage);
  }

  async function moveToDeleteHistoryReport() {
    if (!selectedElement) {
      return;
    }

    const id = selectedElement.id;
    const viewUrl = `/common/deleteHistory?jobname=${JobNames.AEHbl}&id=${id}`;
    
    openNewPage(history, viewUrl, NavigationType.newPage);
  }
  
  async function viewProfit(viewEdit:boolean) {
    if (!selectedElement) {
      return;
    }

    const id = selectedElement.id;
    
    const editUrl = `/airExport/hawb/edit/${id}`;
    const viewUrl = `/airExport/hawb/view/${id}`;

    let editUrlProfitTab = `${editUrl}/6`;
    let viewUrlProfitTab = `${viewUrl}/6`;

    if(viewEdit && jobListContext.hasOpenedScreenStartingWithUrlWithoutMe(`/airExport/hawb/edit`, editUrl)){
        await showGlobalOkDialog(<p>Edit operation is already in progress</p>);
        return;
    }

    jobListContext.moveToOpenedScreenInAnyOperationStartingWithUrl(viewEdit ? editUrlProfitTab : viewUrlProfitTab , [viewUrl, editUrl]);
  }

  async function view() {
    if (!selectedElement) {
      return;
    }

    const id = selectedElement.id;

    const viewUrl = `/airExport/hawb/view/${id}`;
    const editUrl = `/airExport/hawb/edit/${id}`;
    const listSec = findSecurityTask(appContext, FmsSecTask.AEHbl);
    const urls = [viewUrl];
    if (listSec?.grantEdit) urls.push(editUrl)

    jobListContext.moveToOpenedScreenInAnyOperationStartingWithUrl(viewUrl, urls);

  }

  async function copy() {
    if (!selectedElement) {
      return;
    }

    if (jobListContext.hasOpenedScreenStartingWithUrl('/airExport/hawb/add')) {
      await showGlobalOkDialog(<p>New operation is already in progress.</p>);
      return;
    }

    const id = selectedElement.id;
    openNewPage(history, `/airExport/hawb/add?copyId=${id}`, NavigationType.newPage);
  }

  function switchToMawb() {
    const selectedElement = jobListContext.selectedElement as AeHblListItem;
    switchToMawbFor(selectedElement);
  }

  function recognize(isSet: boolean) {
    jobListContext.setRecogModalData({ isOpen: true, isSet: isSet });
  }

  return { create, deleteHbl, edit, view, copy, switchToMawb, recognize, viewBillings, viewProfit, moveToDeleteHistoryReport, setSavedEntityAem };
}


function RightClickMenu({dismiss}:{dismiss: VoidFunction}) {
  const { create, deleteHbl, edit, view, copy, switchToMawb, recognize, viewBillings, viewProfit } = useSelectedHawbOperation();
  const jobListContext = useContext(JobListViewContext);
  const selectedElement = jobListContext.selectedElement as AeHblListItem;
  const appContext = useContext(ApplicationContext);
  const [showGlobalOkDialog] = useGlobalOkDialog();
  const listSec = findSecurityTask(appContext, FmsSecTask.AEHbl);
  const fmsGlobal = getFmsGlobal();

  async function processFileLock() {
    const fileLockResult = await appContext.api.opClose(JobNames.AEHbl, selectedElement.id, !selectedElement.isClosed);
    if (!!fileLockResult) {
      await showGlobalOkDialog(fileLockResult, false, null,'warning');
      return;
    }

    if (selectedElement.isClosed && jobListContext.hasOpenedScreenStartingWithUrl(`/airExport/hawb/edit/${selectedElement.id}`)) {
      const editModelKey = `editAeHawb${selectedElement.id}-/airExport/hawb/edit`;
      const keyMatch = _.keys(fastStorage).find(x => x.startsWith(editModelKey));
      if (keyMatch) {
        fastStorage[keyMatch].fileClosed = 0;
        fastStorage[keyMatch].isFileClosed = false;
        fastStorage[keyMatch].closedBy = '';
        fastStorage[keyMatch].closeDate = null;
      }
    }
    
    jobListContext.reloadData();
  }

  let showFileLock = (!selectedElement?.isClosed ? getFmsGlobal().CanFileLock : getFmsGlobal().CanFileUnlock);
  const lockCancelRecog = selectedElement?.recognized === 'R' && (selectedElement?.status === 'PC' || selectedElement?.status === 'OC');

  const items = [
    { label: 'New', shortcut: 'F2', separator: false, hidden: !listSec?.grantAdd },
    { label: 'View', shortcut: 'F9', separator: !listSec?.grantEdit && !listSec?.grantDel },
    { label: 'Edit', shortcut: 'F3', separator: !listSec?.grantDel, hidden: !listSec?.grantEdit },
    { label: 'Delete', shortcut: '', separator: true, hidden: !listSec?.grantDel },
    { label: 'Search', shortcut: 'F5', separator: false },
    { label: 'Go to MAWB List', shortcut: 'F6', separator: false },
    { label: constants.Doc_Server, shortcut: 'F8', separator: true, newCol: true },
    { label: 'Copy', shortcut: 'Ctrl+F2', separator: false, hidden: !listSec?.grantAdd },
    { label: 'Bilings', shortcut: 'F7', separator: !listSec?.grantEdit },
    { label: 'Profit', shortcut: 'Ctrl+F7', separator: true, hidden: !listSec?.grantEdit },
    // { label: 'View B/L Activity Status', shortcut: '', separator: false },
    { label: !selectedElement?.isClosed ? 'OP Close' : 'OP Open', shortcut: '', separator: false, hidden: !showFileLock },
    // { label: 'Recog', shortcut: '', separator: false, disabled : selectedElement?.recognized === 'R', hidden: !getFmsGlobal().CanFinalize },
    { label: selectedElement?.recognized !== 'R' ? 'Recog' : 'Undo Recog', shortcut: '', separator: false, disabled : lockCancelRecog, hidden: !getFmsGlobal().CanFinalize },
  ];

  const itemStatus = [
    { label: !selectedElement?.isClosed ? 'File Lock' : 'Unlock', shortcut: '', separator: false, hidden: !showFileLock },
  ];

  const menuItems: ActionButtonItem[] = items.map((i, index) =>({
    label: <ToolboxMenuItem name="aeh-list-sub-menu" width="190px" label={i.label} shortcut={i.shortcut} />,
    separator: i.separator,
    selected: false,
    newCol: i.newCol,
    index,
    disabled: i?.disabled ?? false,
    hidden: i?.hidden ?? false,
  }));

  function onMenuItemSelected(item:IfmsMenuItem) {
    switch (item.index) {
      case 0:
        create();
        break;
      case 1:
        view();
        break;
      case 2:
        edit();
        break;
      case 3:
        deleteHbl();
        break;
      case 4:
        jobListContext.triggerTableSearch('F5');
        break;
      case 5:
        switchToMawb();
        break;
      case 6:
        jobListContext.setInfoAreaContent(jobListContext.infoAreaContent === 'memo' ? 'none' : 'memo');;
        break;
      case 7:
        copy();
        break;
      case 8:
        viewBillings();
        break;
      case 9:
        viewProfit(listSec?.grantEdit ? true : false);
        break;
      case 10:
        processFileLock();
        break;
      case 11:
        recognize(selectedElement?.recognized !== 'R');
        break;
      default:
        break;
    }
    dismiss();
  }

  return (
    <Menu
      variant="plain"
      specialMenu='rightClickContext'
      items={splitMenuItemsIntoSections(menuItems)}
      mode="vertical"
      onMenuItemSelected={onMenuItemSelected}
      subMenuStyle={{
        minWidth: 150,
        whiteSpace: 'nowrap',
      }}
      menuStyle={(i: number) => ({
        maxHeight: '300px',
        overflowY: 'hidden',
        padding: 0,
        borderTop: `3px solid ${borderColors[i % borderColors.length]}`,
        paddingTop: 10,
      })}
      dismiss={dismiss}
    />
  );
}

function HawbListViewExtras({
  hideLogHistory
}: any,
) {
  useFunctionKeys({onFunction: onFunctionKey});

  const appContext = useContext(ApplicationContext);
  const jobListContext = useContext(JobListViewContext);
  const history = useHistory();
  const listSec = findSecurityTask(appContext, FmsSecTask.AEHbl);

  const { copy, create, edit, view, switchToMawb, viewBillings, viewProfit } = useSelectedHawbOperation();

  const [unprocessedFkey, setUnprocessedFkey] = useState<string|null>(null);

  useEffect(() => {
      if (!unprocessedFkey) {
        return;
      }

      doProcessFkey();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [unprocessedFkey]
  );

  function doProcessFkey() {
    if (unprocessedFkey === 'F6') {
      switchToMawb();
    } else if (unprocessedFkey === "F2") {
      if(listSec?.grantAdd)
        create();
    } else if (unprocessedFkey === "CTRL+F2") {
      if(listSec?.grantAdd)
        copy();
    }  else if (unprocessedFkey === "F3") {
      if(listSec?.grantEdit)
        edit();
    } else if (unprocessedFkey === "F9") {
      view();
    } else if (unprocessedFkey === "F11") {
      jobListContext.reloadData();
    } else if (unprocessedFkey === "F8") {
      jobListContext.setInfoAreaContent(jobListContext.infoAreaContent === 'memo' ? 'none' : 'memo');
    } else if (unprocessedFkey === "F7") {
      viewBillings();
    }else if (unprocessedFkey === "CTRL+F7") {
      viewProfit(listSec?.grantEdit ? true : false);
    }

    setUnprocessedFkey(null);
  }

  function onFunctionKey(fkey:string) {
    if (['F6', 'F2', 'CTRL+F2', 'F3', 'F9', 'F11', 'F8', 'F7', 'CTRL+F7'].indexOf(fkey) >= 0) {
      setUnprocessedFkey(fkey);
      return true;
    }

    return false;
  }

  const infoHeadline = `HAWB #: ${(jobListContext.selectedElement as AeHblListItem|null)?.hawbNo ?? ''}`;

  return (
    <InfoAreaDrawer
      showContent={jobListContext.infoAreaContent}
      jobName={JobNames.AEHbl}
      jobId={(jobListContext.selectedElement as AeHblListItem|null)?.id ?? 0}
      customTabs={[
        {
          headline: 'Billings Info',
          contentLoader: loadInfoAreaInvoiceBillCrDb,
          params: { appContext, jobListContext, history, infoHeadline }
        },
      ]}
      onClose={() => jobListContext.setInfoAreaContent('none')}
      hideLogHistory={hideLogHistory}
    />
  );
}

function HawbListToolbar() {
  return (
    <>
      <ListViewShortcutMenu />
    </>
  );
}

//#1607
// function AfterMemoLogButtonCommands() {
//   const jobListContext = useContext(JobListViewContext);
//   const selectedElement = jobListContext.selectedElement as AeHblListItem;

//   return (
//     <>
//       &nbsp;&nbsp;
//       <BlackInverseButton size='small' data-tooltip="Go to Carrier's Tracking"
//         onClick={() => window.open(`http://dotnet.freightstream.com/fsutil/customs.asp?mbn=${selectedElement?.mawbNo}`)}>
//         <img height="24px" width='24px' src={carriersTrackingIcon} alt="Go to Carrier's Tracking" style={{ position: 'relative', top: '-1px' }} />
//       </BlackInverseButton>
//     </>
//   )
// }

function TrancationImpactButtonCommands({ userId } : {userId: string}) {
  const jobListContext = useContext(JobListViewContext);
  const selectedElement = jobListContext.selectedElement as AeHblListItem;
  const {switchJournal} = useJournal();
  const suntekSettings = useSuntekSettings();
  
  if (!suntekSettings.general?.allowViewJournalOP && !userId.startsWith('@')) {
    return null;
  }

  return (
    <PrimaryButton
      size="regular"
      onClick={()=> switchJournal(JobNames.AEHbl, selectedElement.id)}>
      {constants.List_Journal}
    </PrimaryButton>
  );
}

function HawbListCommands() {
  const jobListContext = useContext(JobListViewContext);
  const [selectedPopupMenuItem, setSelectedPopupMenuItem] = useState<ActionButtonItem|null>(null);
  const selectedElement = jobListContext.selectedElement as AeHblListItem;
  const setSavedEntityJournal = useSetEditedId([JobNames.SlipJournal]);
  const { deleteHbl, edit, view, copy, viewBillings, moveToDeleteHistoryReport, setSavedEntityAem } = useSelectedHawbOperation();

  // function hasOpenedViewOrEditFor(id:number) {
  //   return jobListContext.hasOpenedScreenStartingWithUrl(`/airExport/mawb/edit/${id}`) || jobListContext.hasOpenedScreenStartingWithUrl(`/airExport/hawb/view/${id}`);
  // }
  
  const [showGlobalYesNoDialog] = useGlobalYesNoDialog();
  const [showGlobalOkDialog] = useGlobalOkDialog();
  const { viewReport } = useReportViewer();
  const appContext = useContext(ApplicationContext);

  function hasOpenedNew() {
    return jobListContext.hasOpenedScreenStartingWithUrl(`/airExport/hawb/add`);
  }

  function doAfterRecog(){
    jobListContext.reloadData();
    setSavedEntityAem(selectedElement.aeMblId?.toString(), false);
    setSavedEntityJournal('0', false, false, true);
  }

  const onRecogModalClose = () => {
    jobListContext.setRecogModalData({ isOpen: false, isSet: false });
  }

  const onPopupClose = () => {
    setSelectedPopupMenuItem(null);
  }

  const onLinkClick = (link: string) => {
    setSelectedPopupMenuItem(null);

    if (!selectedElement) {
      return;
    }
    
    window.open(link);
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const onAesFilingPimsClick = (vanningId: string) => {
    setSelectedPopupMenuItem(null);

    if (!selectedElement) {
      return;
    }
    let source = 'codetest;hykim@ssikor.co.kr;123qwe;2370762'; //for Test
    let key = 'DevPower EnCrypt by Steve Robbins';
    let utf8Encode = new TextEncoder();
    let k = 0;
    let keyChar = utf8Encode.encode(key);
    let result = "";
    let inputChar = utf8Encode.encode(source);

    for(var i = 0;i<inputChar.length;i++){
        result += (inputChar[i] ^ keyChar[k++]).toString(16).toUpperCase().padStart(2, '0');
        if (k >= keyChar.length) k = 0;
    }

    result = (inputChar.length * 2).toString().padStart(6, '0') + result;
    
    window.open('https://aes.suntekscm.com/home/loginrequest/' + result);
  }

  async function onSubMenuClick(fmsSubMenu: FmsSubMenu) {
    setSelectedPopupMenuItem(null);

    if (!selectedElement) {
      return;
    }

    const args = await getSelectedSubMenuArgs(fmsSubMenu, JobNames.AEHbl, selectedElement, appContext, showGlobalYesNoDialog, showGlobalOkDialog);
    if(args){
      viewReport(args, "", true);
    }
  }

  function hasOpenedViewOrEditFor(id:number) {
    return jobListContext.hasOpenedScreenStartingWithUrl(`/airExport/hawb/edit/${id}`) || jobListContext.hasOpenedScreenStartingWithUrl(`/airExport/hawb/view/${id}`);
  }

  const allowedStatuses = ['', 'E', 'D'];

  const listSec = findSecurityTask(appContext, FmsSecTask.AEHbl);

  const hasSelectedRow = !!selectedElement;
  const canBeDeleted = hasSelectedRow && listSec?.grantDel;
  const canBeCopied = hasSelectedRow && !hasOpenedNew() && listSec?.grantAdd;
  const canBeAdd = !hasOpenedNew() && listSec?.grantAdd;
  const canBeEdit = hasSelectedRow && listSec?.grantEdit;

  const openedByF6 = jobListContext.openedByF6 &&
    !!jobListContext.f6Query &&
    jobListContext.f6Origin === '/common/joblistview/aeMawb/airExport';

  const openedByMaster = jobListContext.openedByF6 &&
    !!jobListContext.f6Query &&
    jobListContext.f6Origin === '/airExport/mawb/edit/' + jobListContext.f6Query;

  const newUrl = openedByF6 || openedByMaster
      ? `/airExport/hawb/add?mawbRefId=${jobListContext.f6Query}`
      : '/airExport/hawb/add';

  //const tbName = getTbNameByJobName(JobNames.AEHbl);

  return (
    <div className={!appContext.useDarkMode ? "ifms-common-vertical-separator" : "ifms-common-vertical-separator-darkmode"}>
      <div className="ifms-common-no-vertical-separator">
        <UniqueLinkButton name='aeh-list-add-button' display="primary" size="regular" link={newUrl} disabled={!canBeAdd} label="New" />&nbsp;
        <PrimaryButton name='aeh-list-view-button' size="regular" disabled={!hasSelectedRow} onClick={view}>View</PrimaryButton>&nbsp;
        <PrimaryButton name='aeh-list-edit-button' size="regular" disabled={!canBeEdit} onClick={edit}>Edit</PrimaryButton>&nbsp;
        <PrimaryButton name='aeh-list-delete-button' size="regular" disabled={!canBeDeleted} onClick={deleteHbl}>Delete</PrimaryButton>&nbsp;
        <PrimaryButton name='aeh-list-copy-button' size="regular" disabled={!canBeCopied} onClick={copy}>Copy</PrimaryButton>
      </div>
      <div className={!appContext.useDarkMode ? "ifms-common-vertical-separator" : "ifms-common-vertical-separator-darkmode"}>
        <PrimaryButton size="regular" onClick={viewBillings}>{constants.List_Billings}</PrimaryButton>&nbsp;
        <PrimaryButton size="regular" onClick={moveToDeleteHistoryReport}>Delete History</PrimaryButton>
          </div>
       {/*<div className={!appContext.useDarkMode ? "ifms-common-vertical-separator" : "ifms-common-vertical-separator-darkmode"}>
        <ActionButton
          variant="plain"
          onItemSelected={(event) => setSelectedPopupMenuItem(event)}
          type="primary"
          items={[
            { label: 'AES Filing (Portal)', separator: false, popupComponent: <AesFiling jobName={JobNames.AEHbl} selectedElementId={selectedElement?.id} /> },
            { label: 'AES Filing (iPims)', separator: false, link: 'https://ipims.suntekscm.com/home/loginrequest/' },
            { label: 'Correction Notice/Request', separator: false, popupComponent: <CorrectionNotice jobName={JobNames.AEHbl} selectedElementId={selectedElement?.id} /> },
            { label: 'Pickup/Delivery Instruction', separator: false, popupComponent: <PickupDelivery jobName={JobNames.AEHbl} docType={DocumentType.Pickup} selectedElementId={selectedElement?.id} /> },
            { label: 'Print HAWB', separator: true, popupComponent: <Print jobName={JobNames.AEHbl} selectedElementId={selectedElement?.id} /> },
            { label: 'Est. Profit', separator: true, newCol: true,subMenu: FmsSubMenu.HouseProfit },
            //{ label: 'Go to Carrier\'s Tracking', separator: true, newCol: true, link: 'http://dotnet.freightstream.com/fsutil/customs.asp?mbn=' + selectedElement?.mawbNo },

            { label: 'Air Label', separator: false, popupComponent: <AirLabel docType={DocumentType.LabelAir} jobName={JobNames.AEHbl} selectedElementId={selectedElement?.id} /> },
            { label: 'Bank Draft', separator: false, popupComponent: <BankDraft jobName={JobNames.AEHbl} selectedElement={selectedElement} /> },
            { label: 'Certificate of Origin', separator: false, popupComponent: <CertificateOfOrigin jobName={JobNames.AEHbl} selectedElementId={selectedElement?.id} /> },
            { label: 'Document Package', separator: false, popupComponent: <DocumentPackage jobName={JobNames.AEHbl} selectedElement={selectedElement} /> },
            { label: 'Commercial Invoice', separator: false, popupComponent: <CommercialInvoice selectedElementId={selectedElement?.id} jobName={JobNames.RptCommercialInvoice} tbName={tbName} /> },
            { label: 'Memo List', separator: false, popupComponent: <MemoList selectedElement={selectedElement} jobName={JobNames.AEHbl} />, popupLabel: 'Memo List (HAWB)' },
            { label: 'Memo List (Customer)', separator: false, popupComponent: <MemoList selectedElement={selectedElement} jobName={JobNames.Company} />, popupLabel: 'Memo List (Customer)' },
            { label: 'Package Label', separator: false, popupComponent: <PackageLabel jobName={JobNames.AEHbl} selectedElementId={selectedElement?.id} /> },
            { label: 'Packing List', separator: false, popupComponent: <CommercialInvoice selectedElementId={selectedElement?.id} jobName={JobNames.RptPackingList} tbName={tbName} /> },
            { label: 'Shipping Advice', separator: false, popupComponent: <ShippingAdvice jobName={JobNames.AEHbl} selectedElement={selectedElement} /> },
            { label: 'Straight B/L', separator: true, popupComponent: <StraightBl jobName={JobNames.AEHbl} selectedElementId={selectedElement?.id} /> }

            { label: 'Denied Party (BIS)', separator: false },
            { label: 'Denied Party (OFAC)', separator: false },
            { label: 'Denied Party (ITAR)', separator: false },
          ]}
        >
          More Menu
        </ActionButton>
        &nbsp;
        <BlackInverseButton size='small' data-tooltip="Go to Carrier's Tracking"
          onClick={() => setSelectedPopupMenuItem({ label: 'Go to Carrier\'s Tracking', link: `http://dotnet.freightstream.com/fsutil/customs.asp?mbn=${selectedElement?.mawbNo}` })}>
          <img height="24px" width='24px' src={carriersTrackingIcon} alt="Go to Carrier's Tracking" style={{ position: 'relative', top: '-1px' }} />
        </BlackInverseButton>
      </div> */}
      {!!selectedPopupMenuItem && !!selectedPopupMenuItem.popupComponent ? (
        <IfmsModal isBlueHeader cancelOnEsc onCancel={onPopupClose} draggable isOpen={!!selectedPopupMenuItem} title={selectedPopupMenuItem?.popupLabel || selectedPopupMenuItem?.label} width={`${selectedPopupMenuItem?.popupWidth || 760}px`}>
          {cloneElement(selectedPopupMenuItem.popupComponent!, {onPopupClose})}
        </IfmsModal>
      ) : null}
      {!!selectedPopupMenuItem && !!selectedPopupMenuItem.subMenu ? onSubMenuClick(selectedPopupMenuItem.subMenu) : null}
      {!!selectedPopupMenuItem && !!selectedPopupMenuItem.link ? onLinkClick(selectedPopupMenuItem.link) : null}
      {jobListContext.recogModalData?.isOpen ? (
        <RecogModal reloadData={doAfterRecog} onCancel={onRecogModalClose} mTbId={selectedElement.aeMblId} mTbName={"T_AOMMAIN"} isSet={jobListContext.recogModalData?.isSet} ></RecogModal>
      ) : null}
    </div>
  );
}

function formatData(data:Array<AeHblListItem>) {
  return data.map(d => ({
    ...d,
  }));
}

/**
 * Concrete implementation for AE HAWB List screen
 *
 * @class MawbListView
 * @extends {AbstractListView}
 */
 class HawbListView extends AbstractListView {
  getTableSettings(opType:string, systemSettings:SystemSettings, suntekSettings:SuntekSettings): TableSettings {
    const tsettings = airExportHawbList;
    const useBranch = systemSettings?.enableBranch ?? false;
    const cols = AeHblListItem.getExportCollection(useBranch);
    tsettings.columns = cols.map<TableColumn>(x => {
      return { ...x, accessor: x.dataIndex, Header: x.text, filterType: undefined, filterTypeV2: x.type};
    });
    return tsettings;
  }
  getDefaultOrderBy(): ListOrderBy {
    return {
      orderBy: 'updateDate',
      orderByAscending: false,
    };
  }
  getCustomFilterRenderers(): ListCustomFilterRenderer[] {
    return [
      {
        accessor: 'recognized',
        renderer: RecognizedFilterRenderer,
        searchValueExtractor: (v:any|null|undefined) => v,
      },
      {
        accessor: 'shipmentType',
        renderer: ShipmentTypeFilterRenderer,
        searchValueExtractor: (v: any | null | undefined) => v,
      },
      {
        accessor: 'blType',
        renderer: BlTypeFilterRenderer,
        searchValueExtractor: (v: any | null | undefined) => v,
      },
      {
        accessor: 'invStat',
        renderer: BillInvoiceCrdbFilterRenderer,
        searchValueExtractor: (v: any | null | undefined) => v,
      },
      {
        accessor: 'billStat',
        renderer: BillInvoiceCrdbFilterRenderer,
        searchValueExtractor: (v: any | null | undefined) => v,
      },
      {
        accessor: 'crDbStat',
        renderer: BillInvoiceCrdbFilterRenderer,
        searchValueExtractor: (v: any | null | undefined) => v,
      },
    ];
  }
  getRowRenderers(opType:string, systemSettings:SystemSettings, suntekSettings:SuntekSettings): ListRowRenderer[] {
    const useBranch = systemSettings?.enableBranch ?? false;
    return AeHblListItem.getExportCollection(useBranch).map(x => {
      const colRenderer:ListRowRenderer = { accessor: x.dataIndex, Cell: TextAlignLeftRenderer };
      if(x.align === XCol.XAlignType.Center) colRenderer.Cell = TextRenderer;
      if(x.align === XCol.XAlignType.Right) colRenderer.Cell = TextAlignRightRenderer;
      if (x.dataIndex === "status") {
        colRenderer.Cell = IndicatorRenderer;
      }
      else if(x.dataIndex === "shipmentType") colRenderer.Cell = ShipmentTypeRenderer;
      else if (x.dataIndex === 'recognized') {
          colRenderer.Cell = RecognizedRenderer;
      }
      else if (x.dataIndex === 'paidStat') colRenderer.Cell = PaidRenderer;
      else if(x.dataIndex === 'invStat' || x.dataIndex === 'billStat' || x.dataIndex === 'crDbStat') colRenderer.Cell = BillingsRenderer;
      else if (x.dataIndex === 'shipperName' || x.dataIndex === 'consigneeName' || x.dataIndex === 'notifyName') colRenderer.Cell = TextAlignLeftWithAddressTooltipRenderer
      else if(x.type === XCol.XCellType.Bool || x.type === XCol.XCellType.StrBool) colRenderer.Cell = NullableCheckboxIconRenderer;
      else if(x.type === XCol.XCellType.Date) colRenderer.Cell = DateRenderer;
      else if(x.type === XCol.XCellType.DateTime) colRenderer.Cell = DateTimeRenderer;
      else if (x.type === XCol.XCellType.Double) {
        if (x.dataIndex === 'pkgs' || x.dataIndex === 'lbs'|| x.dataIndex === 'chgLbs')
          colRenderer.Cell = (props: any) => <FloatRenderer {...props} decimals={0} />;
        else if (x.dataIndex === 'kgs' || x.dataIndex === 'chgKgs')
          colRenderer.Cell = (props: any) => <FloatRenderer {...props} decimals={1} />;
        else
          colRenderer.Cell = (props: any) => <FloatRenderer {...props} decimals={2} />;
      }
      else if(x.dataIndex === "blType") colRenderer.Cell = BlTypeRenderer;
      return colRenderer;
    });
  }
    
   getExportRenderers(): ExportRowRenderer[] {
     const colRenderer = [];
     colRenderer.push({ accessor: 'status', changedValue: (value: any) => { return value['status'] === 'PC' ? 'Period Close' : '' } });
     colRenderer.push({ accessor: 'shipmentType', changedValue: (value: any) => { return formatShipmentType(value['shipmentType']) } });
     colRenderer.push({ accessor: 'pkgs', changedValue: (value: any) => { return value['pkgs'] } });
     colRenderer.push({ accessor: 'lbs', changedValue: (value: any) => { return value['lbs'] } });
     colRenderer.push({ accessor: 'chgLbs', changedValue: (value: any) => { return value['chgLbs'] } });
     colRenderer.push({ accessor: 'kgs', changedValue: (value: any) => { return Decimalformat(value['kgs'],1) } });
     colRenderer.push({ accessor: 'chgKgs', changedValue: (value: any) => { return Decimalformat(value['chgKgs'],1) } });
     colRenderer.push({ accessor: 'blType', changedValue: (value: any) => { return formatAEBlType(value['blType']) } });
     return colRenderer;
   }

  async fetchAndFormatData(api: any, search: Search, opType: string): Promise<DataFetchResult> {
    const apiResult = await api.getListItems(
      JobNames.AEHbl,
      'AeHblListItem',
      AeHblListItem.calculateSearchParameters(search, AeHblListItem.MapSearchFields, ['shipmentType', 'invStat', 'billStat', 'crDbStat']),
      1,
      search.pageSize,
      );

      if (!apiResult || !apiResult.entities || apiResult.entities.length <= 0) {
        return {data: [], totalCount: 0};
      }
  
      return {data: formatData(apiResult.entities), totalCount: apiResult.totalCount};
  }
  renderCommands(): React.ReactNode {
    return (
      <HawbListCommands />
    );
  }
  renderBeforeConfigureButton(): React.ReactNode {
    return (
      <HawbListToolbar />
    );
  }
  renderAfterConfigureButton(): React.ReactNode {
    return <></>
  }
  renderExtras(hideLogHistory: boolean): React.ReactNode {
    return <HawbListViewExtras hideLogHistory={hideLogHistory} />
  }
  getViewUrlFor(row: any): string {
    return row && row.id ? `/airExport/hawb/view/${row.id}` : '';
  }
  getListViewTitle(): string {
    return 'HAWB List';
  }
  renderRowExtras(rowId: number | null, context: IJobListViewContext): React.ReactNode|null {
    if (!rowId) {
      return null;
    }

    function onClose() {
      const storageKey = `ae-hawb-milestone-${rowId}`;
      fastStorage[storageKey] = null;
      context.setRowExtrasId(null);
    }

    const hblElement = (context.data ?? []).find( x => x.id === rowId);

    return (
      <IfmsModal isBlueHeader cancelOnEsc onCancel={onClose} draggable isOpen title="B/L Status" width="760px">
        <HawbBlStatusPopup
          hawbNo={hblElement?.hawbNo ?? ''}
          departure={hblElement?.lCode ?? ''}
          arrival={hblElement?.dCode ?? ''}
          eta={hblElement?.eta}
          etd={hblElement?.etd}
          hawbId={rowId}
          storageKey={`ae-hawb-milestone-${rowId}`}
          onClose={onClose}
          isView={false}
        />
      </IfmsModal>
    );
  }
  
  renderAdditionalCommands() {
    return <JobListSuntekCommand jobName={JobNames.AEHbl} keyProp='id' showAdjustBalance={false} showFixJournal={false}/>;
  }

  hasRightClickContext(): boolean {
    return true;
  }

  renderRightClickContext(context: RightClickContext, dismiss: VoidFunction): React.ReactNode {
    return <RightClickMenu dismiss={dismiss} />;
  }

  commandsAfterMemoLogBtn():React.ReactNode{
    //#1607
    // return <AfterMemoLogButtonCommands />
    return null;
  }

  transactionImpactBtn(userId: string): React.ReactNode {
    return <TrancationImpactButtonCommands userId={userId} />
  }
  
  useLogHistory(): boolean {
    return true;
  }
}

export default HawbListView;
